import React from 'react';
import "./header.css"
import { NavLink } from "react-router-dom"; 
import logoSmall from "../imgs/logoSmall.png"; 
import tbtLogo from "../imgs/tbtLogo.png";
export default function Header() {
	return <header className="border-gray sticky top-0 z-[1] w-full flex flex-wrap items-center justify-center gap-8 md:gap-12 border-b-2 border-tbtred bg-white p-4 md:p-6 font-sans font-bold uppercase text-text-primary shadow-md backdrop-blur-[100px] dark:border-gray-800 dark:bg-d-background dark:text-d-text-primary"> 

    <NavLink 
        to="/" 
        className={({ isActive }) => `h-max w-max group transition-all duration-200 hover:scale-110 flex flex-col items-center ${isActive ? 'active' : ''}`}
    >
        <div className="p-2 rounded-lg group-hover:bg-gray-50 transition-colors duration-200">
            <img src={logoSmall} className="h-14 text-center" alt="Home"/>
        </div>
        <p className="text-center text-xs mx-auto w-fit mt-1 mb-0 text-gray-700 group-hover:text-tbtred transition-colors duration-200">Home</p>
    </NavLink>

    <NavLink 
        to="/tbt" 
        className={({ isActive }) => `h-max w-max group transition-all duration-200 hover:scale-110 flex flex-col items-center ${isActive ? 'active' : ''}`}
    >
        <div className="p-2 rounded-lg group-hover:bg-gray-50 transition-colors duration-200">
            <img src={tbtLogo} className="h-14 text-center" alt="TbT"/>
        </div>
        <p className="text-center text-xs mx-auto w-fit mt-1 mb-0 text-gray-700 group-hover:text-tbtred transition-colors duration-200">TbT</p>
    </NavLink>

    <NavLink 
        to="/fencingcamp" 
        className={({ isActive }) => `h-max w-max group transition-all duration-200 hover:scale-110 flex flex-col items-center ${isActive ? 'active' : ''}`}
    >
        <div className="p-2 rounded-lg group-hover:bg-gray-50 transition-colors duration-200">
            <img src={logoSmall} className="h-14 text-center" alt="Camp"/>
        </div>
        <p className="text-center text-xs mx-auto w-fit mt-1 mb-0 text-gray-700 group-hover:text-tbtred transition-colors duration-200">Camp</p>
    </NavLink>

	</header> 
}
